export default __webpack_public_path__ + "static/media/evoralogo.1d87b37a.jpg";